import type React from "react";
import { formatFilterLabel } from "@/utils/filters";
import { getStatusDotColor } from "@/utils/statusColors";
import { FilterSectionHeader, FilterToggle } from "@/v2/ui/composed/filters";

export interface FilterToggleSectionProps {
  title: string;
  items: string[];
  selectedItems: string[];
  onToggle: (item: string) => void;
  formatLabel?: (item: string) => string;
  showStatusColors?: boolean;
  testIdPrefix?: string;
  renderIcon?: (item: string) => React.ReactNode;
  getDotColor?: (item: string) => string;
}

export function FilterToggleSection({
  title,
  items,
  selectedItems,
  onToggle,
  formatLabel = formatFilterLabel,
  showStatusColors = false,
  testIdPrefix,
  renderIcon,
  getDotColor,
}: FilterToggleSectionProps) {
  if (!items || items.length === 0) return null;

  return (
    <div className="tw-space-y-3">
      <FilterSectionHeader title={title} />
      <div className="tw-flex tw-flex-wrap tw-gap-2">
        {items.map((item) => (
          <FilterToggle
            key={item}
            label={formatLabel(item)}
            dotColor={
              getDotColor
                ? getDotColor(item)
                : showStatusColors
                  ? getStatusDotColor(item)
                  : undefined
            }
            icon={renderIcon ? renderIcon(item) : undefined}
            isActive={selectedItems.includes(item)}
            onChange={() => onToggle(item)}
            data-testid={testIdPrefix ? `${testIdPrefix}-${item}` : undefined}
          />
        ))}
      </div>
    </div>
  );
}
